import { Alert } from 'react-bootstrap';

import { ErrorOrigin, Errors, findErrorByField } from '../../_helpers/errorType';

export interface FormErrorProps {
  errors: Errors;
  field?: string;
  alreadyDisplayedErrorFields?: string[];
}

export const RequiredInput = () => {
  return <span className="text-danger">*</span>;
};

const FormError = ({ errors, field, alreadyDisplayedErrorFields }: FormErrorProps) => {
  if (undefined !== field) {
    const error = findErrorByField(errors, field);
    if (undefined !== error) {
      return (
        <Alert className="mt-2 w-100" variant="danger">
          {error.message}
        </Alert>
      );
    }
  } else {
    const errorMessages: string[] = [];

    Object.entries(errors[ErrorOrigin.API]).forEach(([_key, error]) => {
      if (undefined === alreadyDisplayedErrorFields || !alreadyDisplayedErrorFields.includes(error.field)) {
        errorMessages.push(error.message);
      }
    });

    if (errorMessages.length > 0) {
      return (
        <>
          <Alert className="w-100 " variant="danger">
            <ul>
              {errorMessages.map((errorMessage, key) => (
                <li key={key}>{errorMessage}</li>
              ))}
            </ul>
          </Alert>
        </>
      );
    }
  }

  return null;
};

export default FormError;
